import { render, staticRenderFns } from "./extenral-conversation-properties.vue?vue&type=template&id=8f44f608&scoped=true"
import script from "./extenral-conversation-properties.ts?vue&type=script&lang=ts&external"
export * from "./extenral-conversation-properties.ts?vue&type=script&lang=ts&external"
import style0 from "./extenral-conversation-properties.less?vue&type=style&index=0&id=8f44f608&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f44f608",
  null
  
)

export default component.exports